import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useRoleContext, ROLE_HOMES } from "../../context/RoleContext";
import FullScreenSpinner from "./FullScreenSpinner";

/**
 * Route-level guard that restricts access based on active role.
 *
 * @param {string[]} allow  - Allowed roles: "pm", "tenant".
 * @param {React.ReactNode} children
 */
const RoleGuard = ({ allow = [], children }) => {
  const location = useLocation();
  const { activeRole, rolesLoading } = useRoleContext();

  if (rolesLoading) {
    return <FullScreenSpinner />;
  }

  if (!activeRole) {
    return (
      <Navigate
        to={`/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`}
        replace
      />
    );
  }

  if (allow.includes(activeRole)) {
    return <>{children}</>;
  }

  // Wrong role — send to the home for the active role
  return <Navigate to={ROLE_HOMES[activeRole] || "/overview"} replace />;
};

export default RoleGuard;
